<app-base-template (modal)="openModal(content)"(searchmodal) = "searchModal()"(dataExportToExcel)="exportToExcel()" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[showExportBtn]="showExportBtn" [isExportDisable]="isExportDisable"[showSearch]="showSearch"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Map Url With Client</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="clientSelected" (change)="onClientChange($event.target.value)">
        <option *ngFor="let client of clients" [value]="client.id">{{client.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="moduleSelected" (change)="onModuleChange($event.target.value)">
        <option *ngFor="let module of modules" [value]="module.id">{{module.name}}</option>
      </select>
    </div>
    <div class="form-group">

      <mat-radio-group (change)="onRadioButtonChange($event)" class="font-13">
        <mat-radio-button [value]="1">Update Url </mat-radio-button>
        <mat-radio-button [value]="2">Add Url</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="urlSelected" (change)="onUrlChange($event.target.selectedIndex)">
        <option *ngFor="let url of urls" [value]="url.id">{{url.urlKey}}</option>
      </select>
    </div>

    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="url"
             >
    </div>
    <div class="form-group">
      <textarea class="form-control radius-0 font-13" [(ngModel)]="urlDesc" placeholder="Url Description"></textarea>
    </div>

  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>

<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body">

      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter URL key"
                 [(ngModel)]="keySelected">
      </div>
  </div>
  <div class="modal-footer pad-8">

          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>

  </div>

  </ng-template>
<notifier-container></notifier-container>
